// extracted by mini-css-extract-plugin
export var button = "HeaderDesktop-module--button--A7XdD";
export var categoryLink = "HeaderDesktop-module--categoryLink--97600";
export var container = "HeaderDesktop-module--container--OBjsL";
export var highlight = "HeaderDesktop-module--highlight--jza-A";
export var icon = "HeaderDesktop-module--icon--paGvc";
export var link = "HeaderDesktop-module--link--nQJJm";
export var logo = "HeaderDesktop-module--logo--mkL+l";
export var options = "HeaderDesktop-module--options--BwfX9";